import React from "react";

/** Props Interface */
interface AssignmentReferenceBookingRowProps {
	label: string;
	children: React.ReactNode;
}

/**
 * One line of a booking: the label, then the cells it names. A fragment, so the label and the
 * cells are items of the booking's grid. The label opens a new line even when the line before
 * fills fewer cells than there are columns. It is as tall as a single-line input and stays level
 * with its first line when a cell grows beneath it.
 */
export function AssignmentReferenceBookingRow({
	label,
	children,
}: AssignmentReferenceBookingRowProps) {
	/** Render */
	return (
		<React.Fragment>
			<p className="col-start-1 h-9.5 h-stack text-sm label">{label}</p>
			{children}
		</React.Fragment>
	);
}
